import _ from 'lodash'
import { useEffectOnce } from 'react-use'
import ProgramNutritionTable from './table'
import { useLocation } from 'react-router-dom'
import { getDBOptionsPromise } from 'api/Util'
import ProgramNutritionToolBar from './toolbar'
import { getRecipeTagOptionList } from 'api/RecipeTag'
import React, { useState, useEffect, useCallback, useRef, useLayoutEffect } from 'react'

export default function (props) {
  const ref = useRef()
  const location = useLocation()
  const [programNutrition, setProgramNutrition] = useState({})
  const [params, setParams] = useState({ page: 1, filters: {} })
  const [recipeTags, setRecipeTags] = useState([])

  useLayoutEffect(() => {
    getDBOptionsPromise('recipe_tag').then(resp => setRecipeTags(resp.recipe_tag))
  }, [])

  // start
  useEffectOnce(() => {
    const foo = new URLSearchParams(location.search)
    const too = Object.fromEntries(foo.entries())

    setParams({ page: 1, ...too })
  })

  const loadData = useCallback(() => {
    const foo = new URLSearchParams(location.search)
    const too = Object.fromEntries(foo.entries())

    getRecipeTagOptionList(too).then(resp => setProgramNutrition(resp))
  }, [location.search])

  // load data
  useEffect(() => {
    loadData()
  }, [loadData])

  const handleParamsChange = useCallback((payload, delay = 0) => {
    if (ref.current) clearTimeout(ref.current)

    const foo = Object.fromEntries(new URLSearchParams(location.search))
    const too = _.pickBy({ ...foo, page: 1, ...payload }, _.identity)
    setParams(too)

    ref.current = setTimeout(() => props.history.push(`?${new URLSearchParams(too)}`), delay)
  }, [location.search, props.history])


  function handlePageChange (event, page) {
    handleParamsChange({ page: page + 1 })
  }
  // end

  return (
    <div className={'root'}>
      <ProgramNutritionToolBar {...props} recipeTags={recipeTags} params={params} onParamsChange={handleParamsChange} />
      <div className={'content'}>
        <ProgramNutritionTable {...props} recipeTags={recipeTags} data={programNutrition} page={params.page} onPageChange={handlePageChange} />
      </div>
    </div>
  )
}
